import useSWR from 'swr'
import { Assessments } from '@crystal-eyes/types'
import getAssessments from '@crystal-eyes/data/profiles/getAssessments'

interface Identity {
  id: string
  rootSnapshot?: {id: string, assessments?: Assessments}
}

type Options = {
  identity?: Identity
}

export type State = {
  data?: Assessments
  refresh: () => void
  loading?: boolean
  error?: any
}

export default function useAssessments({ identity }: Options): State {
  const fetcher = ([_key, identity]: [string, { id: string }]) =>
    getAssessments({ identity })

  const {
    data,
    isLoading: loading,
    error: error,
    mutate,
  } = useSWR(
    identity ? ['useAssessments', { id: identity.id }] : null,
    fetcher,
    {
      revalidateOnFocus: false,
      keepPreviousData: true,
      fallbackData: identity?.rootSnapshot?.assessments,
    },
  )

  return {
    data,
    loading,
    error,
    refresh: () => {
      mutate()
    },
  }
}
